import type { Nullable } from 'common/types'

export const isStringNullOrEmpty = (str: Nullable<string> | undefined) =>
  str == null || str.trim().length === 0

export const isStringNonEmpty = (str: Nullable<string> | undefined): str is string =>
  str != null && str.trim().length > 0
